import React from "react";

const LifeAtAppVerse = () => {

    return (
        <>
            <section className="life-section">

                <div className="life-glow glow1"></div>
                <div className="life-glow glow2"></div>

                <div className="life-container">

                    <div className="life-top">

                        <span>LIFE AT APPVERSELABS</span>

                        <h2>
                            Where Great
                            <br />
                            Ideas Become
                            <br />
                            Products
                        </h2>

                        <p>
                            We believe in building an environment
                            where creativity, ownership and innovation
                            thrive together.
                        </p>

                    </div>

                    <div className="life-showcase">

                        {/* Main Image */}

                        <div className="life-image">

                            <img
                                src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f"
                                alt=""
                            />

                        </div>

                        {/* Floating Cards */}


                    </div>

                </div>

                <style>{`

                .life-section{
                    position:relative;
                    padding:160px 24px;
                    background:#fff;
                    overflow:hidden;
                }

                .life-container{
                    max-width:1400px;
                    margin:auto;
                    position:relative;
                    z-index:2;
                }

                .life-top{
                    text-align:center;
                    margin-bottom:90px;
                }

                .life-top span{
                    display:inline-block;
                    padding:12px 22px;
                    border-radius:999px;
                    background:rgba(232,33,42,.08);
                    color:#E8212A;
                    font-size:13px;
                    font-weight:700;
                    margin-bottom:24px;
                }

                .life-top h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    color:#111;
                    margin-bottom:25px;
                        text-align: center;
                    font-family:'Syne',sans-serif;
                }

                .life-top p{
                    max-width:700px;
                        text-align: center;
                    margin:auto;
                    color:#666;
                    line-height:1.9;
                    font-size:18px;
                }

                .life-showcase{
                    position:relative;
                    height:850px;
                }

                .life-image{
                    position:absolute;
                    left:50%;
                    top:50%;
                    transform:translate(-50%,-50%);
                    width:700px;
                    height:500px;
                    border-radius:40px;
                    overflow:hidden;
                    box-shadow:
                    0 40px 100px rgba(0,0,0,.15);
                }

                .life-image img{
                    width:100%;
                    height:100%;
                    object-fit:cover;
                    transition:.6s;
                }

                .life-image:hover img{
                    transform:scale(1.08);
                }

                .life-card{
                    position:absolute;
                    width:260px;
                    background:#fff;
                    border:1px solid #eee;
                    border-radius:30px;
                    padding:30px;
                    box-shadow:
                    0 20px 60px rgba(0,0,0,.06);
                    transition:.4s;
                }

                .life-card:hover{
                    transform:translateY(-12px);
                    box-shadow:
                    0 30px 80px rgba(232,33,42,.12);
                }

                .life-icon{
                    width:70px;
                    height:70px;
                    border-radius:20px;
                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );
                    display:flex;
                    align-items:center;
                    justify-content:center;
                    font-size:30px;
                    margin-bottom:20px;
                    color:#fff;
                }

                .life-card h3{
                    font-size:28px;
                    color:#111;
                    margin-bottom:12px;
                    font-family:'Syne',sans-serif;
                }

                .life-card p{
                    color:#666;
                    line-height:1.8;
                    font-size:14px;
                }

                .card-1{
                    left:0;
                    top:60px;
                }

                .card-2{
                    right:0;
                    top:100px;
                }

                .card-3{
                    left:60px;
                    bottom:80px;
                }

                .card-4{
                    right:60px;
                    bottom:100px;
                }

                .life-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.12;
                }

                .glow1{
                    width:400px;
                    height:400px;
                    background:#E8212A;
                    top:-100px;
                    left:-100px;
                }

                .glow2{
                    width:350px;
                    height:350px;
                    background:#FF4D4D;
                    right:-100px;
                    bottom:-100px;
                }

                @media(max-width:1100px){

                    .life-showcase{
                        display:grid;
                        grid-template-columns:1fr 1fr;
                        gap:25px;
                        height:auto;
                    }

                    .life-image{
                        position:relative;
                        width:100%;
                        height:420px;
                        left:auto;
                        top:auto;
                        transform:none;
                        grid-column:span 2;
                    }

                    .life-card{
                        position:relative !important;
                        width:100%;
                        left:auto !important;
                        right:auto !important;
                        top:auto !important;
                        bottom:auto !important;
                    }

                }

                @media(max-width:768px){

                    .life-showcase{
                        grid-template-columns:1fr;
                    }

                    .life-image{
                        grid-column:span 1;
                    }

                    .life-top h2{
                        letter-spacing:-2px;
                    }

                    .life-section{
                        padding:100px 18px;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default LifeAtAppVerse;